// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__Fs-Yu","log":"ModalInventoryLogs_log__2CYoh","date":"ModalInventoryLogs_date__3I2eI","userName":"ModalInventoryLogs_userName__1dDOy"};